import { render, staticRenderFns } from "./vendorMapping.vue?vue&type=template&id=545327bc&scoped=true"
import script from "./vendorMapping.vue?vue&type=script&lang=js"
export * from "./vendorMapping.vue?vue&type=script&lang=js"
import style0 from "./vendorMapping.vue?vue&type=style&index=0&id=545327bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545327bc",
  null
  
)

export default component.exports